var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 126.04,
    height: 126.04,
    viewBox: "0 0 126.04 126.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00f2fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#03effe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#24d2fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#3cbdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796,
    stopColor: "#4ab0fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4facfe"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "play",
    d: "M63.02,126.039A63.02,63.02,0,0,1,18.458,18.457,62.979,62.979,0,0,1,115.362,98a4.923,4.923,0,1,1-8.185-5.473,52.82,52.82,0,1,0-16.65,16,4.923,4.923,0,1,1,5.1,8.422,62.918,62.918,0,0,1-32.608,9.082ZM57.667,86.231,82.211,72.012a10.4,10.4,0,0,0,0-17.986L57.667,39.807A10.376,10.376,0,0,0,42.095,48.8V77.238a10.352,10.352,0,0,0,15.572,8.993Zm-4.936-37.9L77.274,62.546a.55.55,0,0,1,0,.946L52.731,77.712a.472.472,0,0,1-.519,0,.5.5,0,0,1-.27-.473V48.8a.5.5,0,0,1,.27-.473.522.522,0,0,1,.263-.077.5.5,0,0,1,.256.077Zm0,0",
    transform: "translate(0 0.001)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.81a4778216d9d97a5e28e54ab6df1ade.svg";
export { ForwardRef as ReactComponent };